export enum DedupMatchingType {
  LEAD_TO_LEAD_DEDUP = 'LeadToLeadDedup',
  LEAD_TO_ACCOUNT_MATCHING = 'LeadToAccountMatching',
  LEAD_TO_CONTACT_DEDUP = 'LeadToContactDedup',
  LEAD_TO_LEAD_MATCHING = 'LeadToLeadMatching',
  ACCOUNT_TO_ACCOUNT_DEDUP = 'AccountToAccountDedup',
  CONTACT_TO_CONTACT_DEDUP = 'ContactToContactDedup',
  CASE_TO_CASE_DEDUP = 'CaseToCaseDedup',
  OPP_TO_OPP_DEDUP = 'OppToOppDedup',
}

export enum SweepFilterEndpoint {
  SOURCE = 'SOURCE',
  DESTINATION = 'DESTINATION',
  MATCH = 'MATCH',
}
